/**
 *
 * ModalCustom
 *
 */

import React from "react"
import { Modal, Button } from "antd"
import "./index.less"
import PropTypes from "prop-types"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { loadTexts, sanitize } from "../../utils/i18n"

const ModalCustom = (props) => {
  let intl = loadTexts("dashboard")
  let modalType = props.model || ""
  let isLoading = props.isLoadingCompleteStepData || false
  let footer = null
  let style = {}
  if (props.disabledButton) {
    style = {
      backgroundColor: props.colorButton || "#C4C4C4",
      borderColor: props.colorButton || "#C4C4C4",
      color: !props.disabledButton || "#FFF",
    }
  } else {
    style = {
      backgroundColor: props.colorButton || "#1890ff",
      borderColor: props.colorButton || "#1890ff",
      color: !props.disabledButton || "#FFF",
    }
  }
  if (props.showFooter) {
    footer = [
      <Button
        key="back"
        className="cancelButton"
        onClick={() => {
          woopraTrack(
            props.action
              ? `Cancelar ${props.action}`
              : modalType !== ""
              ? `Cancelar Crear ${modalType}`
              : "Cancelar"
          )
          props.onCancel()
        }}>
        {props.textCancelButton || intl.modalActionPlanCreate.exitModal.cancel}
      </Button>,
      <Button
        disabled={props.disabledButton}
        loading={props.isLoadingButton}
        style={style}
        key="submit"
        id={props.onOkId}
        onClick={() => {
          woopraTrack(
            props.action
              ? `Aceptar ${props.action}`
              : modalType != ""
              ? `Aceptar Crear ${modalType}`
              : "Aceptar"
          )
          props.onOk()
        }}
        type={"danger" || "primary"}>
        {props.textButton || intl.modalActionPlanCreate.exitModal.accept}
      </Button>,
    ]
  } else if (props.showOnlyAccept) {
    footer = [
      <Button
        type={props.okType || "primary"}
        disabled={props.disabledButton}
        loading={props.isLoadingButton}
        style={style}
        key="submit"
        id={props.onOkId}
        onClick={() => props.onOk()}>
        {props.textButton || intl.modalActionPlanCreate.exitModal.accept}
      </Button>,
    ]
  } else if (props.showOnlyCancel) {
    footer = [
      <Button
        key="back"
        className="cancelButton"
        onClick={() => props.onCancel()}>
        {props.textCancelButton || intl.modalActionPlanCreate.exitModal.cancel}
      </Button>,
    ]
  }

  return (
    <Modal
      width={props.width || 520}
      className="modalCustomSup"
      style={{ top: 76 }}
      title={props.title}
      closable={!!props.title}
      visible={props.modalOpen}
      {...(props.onCancel ? { onCancel: () => props.onCancel() } : {})}
      footer={footer}
      bodyStyle={props.bodyStyle}>
      <div
        className="modalCustom"
        style={{
          margin: props.margin || "0 auto",
          textAlign: props.textAlign || "center",
        }}>
        {/* Always in order
              <img />
              <p />
              <p />
              ..
              ..
              ..
        */}
        {props.children}
      </div>
    </Modal>
  )
}

Modal.propTypes = {
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  showOnlyAccept: PropTypes.func,
  disabledButton: PropTypes.bool,
  colorButton: PropTypes.string,
  textButton: PropTypes.string,
  // title: PropTypes.string,
  modalOpen: PropTypes.bool,
  margin: PropTypes.string,
  textAlign: PropTypes.string,
  isLoadingButton: PropTypes.bool,
}

Modal.defaultProps = { type: "primary" }

export default ModalCustom
